'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  .tooltiptext {\n    position: absolute;\n    visibility: hidden;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    padding: 5px 0;\n    border-radius: 6px;\n    width: 120px;\n    top: 100%;\n    left: 50%;\n    margin-left: -60px;\n  }\n  &:hover .tooltiptext {\n    visibility: visible;\n  }\n  .tooltiptext::after {\n    content: " ";\n    position: absolute;\n    top: 0%; /* At the top of the tooltip */\n    left: 50%;\n    margin-top: -10px;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color:  transparent transparent black transparent;\n  }\n  .tooltip-left {\n    left: unset;\n    right: 0%;\n    &::after {\n      left: unset;\n      right: 5%;\n    }\n  }\n'], ['\n  position: relative;\n  .tooltiptext {\n    position: absolute;\n    visibility: hidden;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    padding: 5px 0;\n    border-radius: 6px;\n    width: 120px;\n    top: 100%;\n    left: 50%;\n    margin-left: -60px;\n  }\n  &:hover .tooltiptext {\n    visibility: visible;\n  }\n  .tooltiptext::after {\n    content: " ";\n    position: absolute;\n    top: 0%; /* At the top of the tooltip */\n    left: 50%;\n    margin-top: -10px;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color:  transparent transparent black transparent;\n  }\n  .tooltip-left {\n    left: unset;\n    right: 0%;\n    &::after {\n      left: unset;\n      right: 5%;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipWrapper = _styledComponents2.default.span(_templateObject);

/** @class Tooltip
  * Displays a tooltip when the mouse hovers over
  * the children components.
  * @param {string} text - the text to display
  */

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: 'render',

    /** @method render
      * Renders the tooltip.
      */
    value: function render() {
      var className = "tooltiptext";
      if (this.props.orientation == "left") className += " tooltip-left";
      return _react2.default.createElement(
        TooltipWrapper,
        null,
        this.props.children,
        _react2.default.createElement(
          'span',
          { className: className },
          this.props.text
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;


Tooltip.propTypes = {
  text: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/tooltip/tooltip.js
// module id = 178
// module chunks = 0